let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("4sSvI")).then(() => parcelRequire('dcEuZ'));